import { Observable } from 'rxjs';
import { MeterItem, MeterPaginatedResponse, AlertPaginatedResponse, MeterQueryParams, MeterLookupParams, AlertQueryParams, MeterHealthParams, LinkMeterBody } from '../models/meter-manage.model';

export abstract class MeterAbstractService {
    abstract getMeters(params?: MeterQueryParams): Observable<MeterPaginatedResponse>;
    abstract lookupMeters(params: MeterLookupParams): Observable<MeterItem[]>;
    abstract getAlerts(params?: AlertQueryParams): Observable<AlertPaginatedResponse>;
    abstract getUnassigned(page?: number, limit?: number): Observable<MeterPaginatedResponse>;
    abstract getHealth(params?: MeterHealthParams): Observable<MeterPaginatedResponse>;
    abstract linkMeter(userId: string, body: LinkMeterBody): Observable<any>;
}
